import axios from 'axios';
import {getAuthHeader} from  '../global_helpers/authHeader.js';


const state = {
    settingsContext: {
        proposal: {
            takeoverTypeOptions: null,
            takeoverTypeDefaults: null
        }
    }
};

const getters = {
    loadProposalSettings: (state) => state.settingsContext.proposal
};

const actions = {
    async fetchProposalSettings({commit, dispatch}, setting){
        // Setting object passes entity object with type and id props, and the setting name
        let authHeader = getAuthHeader();
        let endpoint = "/setting/?entity_type="+setting.entity.type+"&entity_id="+setting.entity.id+"&setting_name="+setting.setting_name;
        axios.get(endpoint, authHeader)
        
        .then((res) => {
            commit('setTakeoverOptions', res.data);
        })
        .catch(err => {
            console.log(err);
            dispatch('raiseMessage', "There was an error loading your company's Takeover Type Options!", {root: true});
        });
    },
    
    async fetchPricingDefaults({commit, dispatch}, setting){
        // Setting object passes entity object with type and id props, and the setting name
        let authHeader = getAuthHeader();
        let endpoint = "/setting/?entity_type="+setting.entity.type+"&entity_id="+setting.entity.id+"&setting_name="+setting.setting_name;
        axios.get(endpoint, authHeader)
        
        .then((res) => {
            commit('setTakeoverDefaults', res.data);
        })
        .catch(err => {
            console.log(err);
            dispatch('raiseMessage', "There was an error loading your company's Pricing Parameter Defaults!", {root: true});
        });
    },
};

const mutations = {
    setTakeoverOptions(state, data){
        state.settingsContext.proposal.takeoverTypeOptions = data;
    },
    setTakeoverDefaults(state, data){
        state.settingsContext.proposal.takeoverTypeDefaults = data;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};